import { Link } from '@mui/material'
import React from 'react'
import MediaQuery from 'react-responsive'
import Logotipo from '../../images/monefica.svg'
import { useMixpanel } from '../../mixpanel-hook/mixpanel-context'
import * as S from './styles'
const trackClickBuilder = (mixpanel) => (url, field) =>{
	if(mixpanel){
		mixpanel.track(`Navbar click: ${field}`)
	}
	window.location = url;
}

export function Header({ theme }) {
	const mixpanel = useMixpanel()
	const trackClick = trackClickBuilder(mixpanel)

	return (<S.Header bgColor={theme.palette.primary.main}>
		<S.Container maxWidth={theme.config.containerWidth}>
			<S.Logotipo src={Logotipo} alt="Monefica" title="Monefica"/>
			<MediaQuery query="(min-width: 1024px)">
				<div style={{display: 'flex', flexDirection:'row'}}>
					<S.NavItem onClick={()=> trackClick("https://monefica.com.br", 'HOME')}>HOME</S.NavItem>
					<S.NavItem onClick={()=> trackClick("https://simulador.monefica.com.br", 'SIMULADOR')}>SIMULADOR DE APOSENTADORIA</S.NavItem>
					<S.NavItem onClick={()=> trackClick("https://monefica.com.br/sobre-nos", 'SOBRE NÓS')}>SOBRE NÓS</S.NavItem>
					<S.NavItem onClick={()=> trackClick("https://app.monefica.com.br/cadastro", 'CURSOS GRATUITOS')}>CURSOS GRATUITOS</S.NavItem>
					<S.NavItem onClick={()=> trackClick("https://monefica.com.br/?page_id=10", 'BLOG')}>BLOG</S.NavItem>
					<S.NavItem onClick={()=> trackClick("https://monefica.com.br/contato", 'CONTATO')}>CONTATO</S.NavItem>
				</div>
			</MediaQuery>
		</S.Container>
	</S.Header>)
}
